import { z } from 'zod';

/**
 * Mode de rendez-vous capturé dans le wizard.
 *
 *   - `immediate` : rappel direct par le call-center du partenaire, gaté
 *     par les horaires d'ouverture. Pas de `scheduledFor`.
 *   - `scheduled` : rappel planifié à `Lead.scheduledFor` (UTC).
 */
export const AppointmentMode = {
  immediate: 'immediate',
  scheduled: 'scheduled',
} as const;

export type AppointmentMode = (typeof AppointmentMode)[keyof typeof AppointmentMode];

export const AppointmentModeSchema = z.nativeEnum(AppointmentMode);
